// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import DigitalCity from '@/assets/img/DigitalCity.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import LoadingComponent from '@/components/common/LoadingComponent';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//     { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
//     { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: o.iur250 ?? '-' }] },
//     { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
//     { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
//     { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
//     { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//     { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//     { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//     { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
//     { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const DIGITAL_CITY_OFF_STREET_CONFIG = {
//   digital_city_off_street_profile: {
//     profileKey:    'digital_city_off_street_profile',
//     violationKey:  'digital_city_off_street_violations',
//     membershipKey: 'digital_city_off_street_membership',
//     tariffKey:     'digital_city_off_street_tariff',
//     assetsKey:     'digital_city_off_street_assets',
//     pageType:      'off_street',

//     profileFallback: {
//       table_key: 'digital_city_off_street_profile',
//       title: 'Digital City Off Street - Profile',
//       data: {
//         total_bays:        { label: 'Total Off Street Car Park Bays', value: '6,736' },
//         contract_term:     { value: '05 years' },
//         contract_period:   { start_date: '01st April 2025', end_date: '31st March 2030' },
//         operational_hours: { value: '12 Hours Per day' },
//         rate_per_hour:     { value: 'As per below table' },
//         membership_tariff: { value: 'Membership Rates: As per below table' },
//       },
//     },

//     violationFallback: {
//       table_key: 'digital_city_off_street_violations',
//       title: 'OFF STREET VIOLATIONS',
//       data: {
//         rows: [
//           { violation_type: 'Not parked within the parking space',                                               first_cn: '300', second_cn: '575', subsequent_cn: '575', escalation_notes: '2nd violation - clamping, 3rd violation - Removal to the pound' },
//           { violation_type: 'Parked in an official reserved space',                                              first_cn: '300', second_cn: '575', subsequent_cn: '575', escalation_notes: 'Towing/Clamping/Pound' },
//           { violation_type: 'Parked in a prohibited parking space',                                              first_cn: '300', second_cn: '575', subsequent_cn: '575', escalation_notes: 'Towing/Clamping/Pound' },
//           { violation_type: 'Placing obstacles or reservations on the parking',                                  first_cn: '400', second_cn: '600', subsequent_cn: '900', escalation_notes: 'Cost of removing' },
//           { violation_type: 'Parking in front of doorway, pedestrian entry and exits',                          first_cn: '900', second_cn: '900', subsequent_cn: '900', escalation_notes: 'Towing/Pound' },
//           { violation_type: 'Parked the Vehicle on pedestrian area, double parking or building entries and exits', first_cn: '575', second_cn: '575', subsequent_cn: '575', escalation_notes: 'Towing/Pound' },
//           { violation_type: 'Abusive behavior',                                                                  first_cn: 'Removal of Parking Access',colSpan: 3,escalation_notes: '' },
//           { violation_type: 'Blocking an Entrance',                                                              first_cn: '575', second_cn: '900', subsequent_cn: '900', escalation_notes: null },
//           { violation_type: 'Parking in a Non-parking area',                                                     first_cn: '575', second_cn: '575', subsequent_cn: '575', escalation_notes: null },
//           { violation_type: 'Parking in handicapped spaces without a permit',                                    first_cn: '575', second_cn: '575', subsequent_cn: '575', escalation_notes: null },
//           { violation_type: 'Forced Entry',                                                                      first_cn: '900', second_cn: '900', subsequent_cn: '900', escalation_notes: null },
//         ],
//         towing_rows: [
//           { charge_type: 'Towing light Vehicles Charge', amount: '300' },
//           { charge_type: 'Towing Heavy Vehicles',        amount: '1000' },
//         ],
//         storage_rows: [
//           { charge_type: 'Daily delay in light vehicle retrieval',  amount: '100', notes: 'Daily Storage amount, Violation fee is charged separately' },
//           { charge_type: 'Daily delay in heavy vehicle retrieval',  amount: '300', notes: 'Daily Storage amount, Violation fee is charged separately' },
//         ],
//       },
//     },

//     membershipFallback: {
//       table_key: 'digital_city_off_street_membership',
//       title: 'Off Street memberships',
//       data: {
//         rows: [
//           { category: 'Basement Car Parks',             amount: '2,500', period: '30,000' },
//           { category: 'Basement Car Parks Reserved bay', amount: '4,000', period: '48,000' },
//           { category: 'Surface Car Park (TE01)',         amount: '1,200', period: '14,400' },
//           { category: 'Basement Car Park SPAGA',         amount: '1,500', period: '1,800'  },
//           { category: 'Surface Car Park SPAGA',          amount: '1,000', period: '12,000' },
//         ],
//       },
//     },

//     tariffFallback: {
//       table_key: 'digital_city_off_street_tariff',
//       title: 'Off Street visitor parking (PK-01)',
//       data: {
//         rows: [
//           { duration: '1-3 Hours',  rate: '30'  },
//           { duration: '4-6 Hours',  rate: '60'  },
//           { duration: '7-9 Hours',  rate: '90'  },
//           { duration: '9+ Hours',   rate: '300' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'digital_city_off_street_assets',
//       title: 'Digital City Off Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '15', dipG100: '15',
//           ticketVerifier: '15', evG10064: '15',
//           apms: '3', apmEts70: '3',
//           pinPad: '3', cardReader: '3', iur250: '3',
//           bContactless: '3',
//           rfidReader: '-', ipBarrier: '-', anprCamera: '-',
//           slidingGate: '-', pnds: '-',
//           enfDevice: '-', printer: '-',
//           towTruck: '-', clampVehicle: '-', supportVehicle: '-',
//         }),
//       },
//     },
//   },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const DigitalCityOffStreetProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = DIGITAL_CITY_OFF_STREET_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [profileData, setProfileData] = useState(null);
//   const [assetsData, setAssetsData] = useState(null);
//   const [violationData, setViolationData] = useState(null);
//   const [membershipData, setMembershipData] = useState(null);
//   const [tariffData, setTariffData] = useState(null);
//   const { enqueue } = useApiQueue();

//   // Refs for profile inputs
//   const totalBaysRef = useRef(null);
//   const contractTermRef = useRef(null);
//   const contractStartDateRef = useRef(null);
//   const contractEndDateRef = useRef(null);
//   const operationalHoursRef = useRef(null);
//   const ratePerHourRef = useRef(null);
//   const membershipTariffRef = useRef(null);

//   // Refs for violation rows
//   const violationTypeRefs = useRef([]);
//   const violationFirstCnRefs = useRef([]);
//   const violationSecondCnRefs = useRef([]);
//   const violationSubsequentCnRefs = useRef([]);
//   const violationEscalationRefs = useRef([]);

//   // Refs for towing rows
//   const towingTypeRefs = useRef([]);
//   const towingAmountRefs = useRef([]);

//   // Refs for storage rows
//   const storageTypeRefs = useRef([]);
//   const storageAmountRefs = useRef([]);
//   const storageNotesRefs = useRef([]);

//   // Refs for membership rows
//   const membershipCategoryRefs = useRef([]);
//   const membershipAmountRefs = useRef([]);
//   const membershipPeriodRefs = useRef([]);

//   // Refs for tariff rows
//   const tariffDurationRefs = useRef([]);
//   const tariffRateRefs = useRef([]);

//   // Refs for assets
//   const assetSubCountRefs = useRef([]);
//   const assetTotalCountRefs = useRef([]);

//   // State refs for data
//   const profileDataRef = useRef(null);
//   const assetsDataRef = useRef(null);
//   const violationDataRef = useRef(null);
//   const membershipDataRef = useRef(null);
//   const tariffDataRef = useRef(null);

//   // Fetch data
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;
      
//       const profile = find(cfg.profileKey, cfg.profileFallback);
//       const assets = find(cfg.assetsKey, cfg.assetsFallback);
//       const violation = find(cfg.violationKey, cfg.violationFallback);
//       const membership = find(cfg.membershipKey, cfg.membershipFallback);
//       const tariff = find(cfg.tariffKey, cfg.tariffFallback);
      
//       setProfileData(profile);
//       setAssetsData(assets);
//       setViolationData(violation);
//       setMembershipData(membership);
//       setTariffData(tariff);
      
//       profileDataRef.current = profile;
//       assetsDataRef.current = assets;
//       violationDataRef.current = violation;
//       membershipDataRef.current = membership;
//       tariffDataRef.current = tariff;
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // Auto-save
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   const transformAssetsToApiFormat = () => {
//     const currentAssets = assetsDataRef.current?.data?.groups || [];
//     const groups = [];
//     let currentGroup = null;
//     let flatIdx = 0;

//     currentAssets.forEach((group) => {
//       currentGroup = {
//         group_name: group.group_name,
//         group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
//         items: []
//       };
//       flatIdx++;

//       (group.items || []).forEach((item) => {
//         currentGroup.items.push({
//           item_name: item.item_name,
//           qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
//         });
//         flatIdx++;
//       });

//       groups.push(currentGroup);
//     });

//     return groups;
//   };

//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       // Get current values from refs
//       const currentTotalBays = totalBaysRef.current?.value || profileDataRef.current?.data?.total_bays?.value || '';
//       const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
//       const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
//       const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
//       const currentOperationalHours = operationalHoursRef.current?.value || profileDataRef.current?.data?.operational_hours?.value || '';
//       const currentRatePerHour = ratePerHourRef.current?.value || profileDataRef.current?.data?.rate_per_hour?.value || '';
//       const currentMembershipTariff = membershipTariffRef.current?.value || profileDataRef.current?.data?.membership_tariff?.value || '';

//       // Build violation rows from refs
//       // const currentViolationRows = (violationDataRef.current?.data?.rows || []).map((row, rIdx) => ({
//       //   violation_type: violationTypeRefs.current[rIdx]?.value || row.violation_type || '',
//       //   first_cn: violationFirstCnRefs.current[rIdx]?.value || row.first_cn || '',
//       //   second_cn: violationSecondCnRefs.current[rIdx]?.value || row.second_cn || '',
//       //   subsequent_cn: violationSubsequentCnRefs.current[rIdx]?.value || row.subsequent_cn || '',
//       //   escalation_notes: violationEscalationRefs.current[rIdx]?.value || row.escalation_notes || ''
//       // }));


//       // Build violation rows from refs
// const currentViolationRows = (violationDataRef.current?.data?.rows || []).map((row, rIdx) => {
//   const newRow = {
//     violation_type: violationTypeRefs.current[rIdx]?.value || row.violation_type || '',
//     first_cn: violationFirstCnRefs.current[rIdx]?.value || row.first_cn || '',
//     second_cn: violationSecondCnRefs.current[rIdx]?.value || row.second_cn || '',
//     subsequent_cn: violationSubsequentCnRefs.current[rIdx]?.value || row.subsequent_cn || '',
//     escalation_notes: violationEscalationRefs.current[rIdx]?.value || row.escalation_notes || null
//   };
  
//   // Preserve colSpan if it exists in the original row
//   if (row.colSpan) {
//     newRow.colSpan = row.colSpan;
//   }
  
//   return newRow;
// });
//       // Build towing rows from refs
//       const currentTowingRows = (violationDataRef.current?.data?.towing_rows || []).map((row, rIdx) => ({
//         charge_type: towingTypeRefs.current[rIdx]?.value || row.charge_type || '',
//         amount: towingAmountRefs.current[rIdx]?.value || row.amount || ''
//       }));

//       // Build storage rows from refs
//       const currentStorageRows = (violationDataRef.current?.data?.storage_rows || []).map((row, rIdx) => ({
//         charge_type: storageTypeRefs.current[rIdx]?.value || row.charge_type || '',
//         amount: storageAmountRefs.current[rIdx]?.value || row.amount || '',
//         notes: storageNotesRefs.current[rIdx]?.value || row.notes || ''
//       }));

//       // Build membership rows from refs
//       const currentMembershipRows = (membershipDataRef.current?.data?.rows || []).map((row, rIdx) => ({
//         category: membershipCategoryRefs.current[rIdx]?.value || row.category || '',
//         amount: membershipAmountRefs.current[rIdx]?.value || row.amount || '',
//         period: membershipPeriodRefs.current[rIdx]?.value || row.period || ''
//       }));

//       // Build tariff rows from refs
//       const currentTariffRows = (tariffDataRef.current?.data?.rows || []).map((row, rIdx) => ({
//         duration: tariffDurationRefs.current[rIdx]?.value || row.duration || '',
//         rate: tariffRateRefs.current[rIdx]?.value || row.rate || ''
//       }));

//       const tables = [
//         {
//           table_key: profileDataRef.current?.table_key || cfg.profileKey,
//           title: profileDataRef.current?.title || cfg.profileFallback.title,
//           data: {
//             total_bays: { label: 'Total Off Street Car Park Bays', value: currentTotalBays },
//             contract_term: { value: currentContractTerm },
//             contract_period: { start_date: currentStartDate, end_date: currentEndDate },
//             operational_hours: { value: currentOperationalHours },
//             rate_per_hour: { value: currentRatePerHour },
//             membership_tariff: { value: currentMembershipTariff }
//           }
//         },
//         {
//           table_key: assetsDataRef.current?.table_key || cfg.assetsKey,
//           title: assetsDataRef.current?.title || cfg.assetsFallback.title,
//           data: { groups: transformAssetsToApiFormat() }
//         },
//         {
//           table_key: violationDataRef.current?.table_key || cfg.violationKey,
//           title: violationDataRef.current?.title || cfg.violationFallback.title,
//           data: {
//             rows: currentViolationRows,
//             towing_rows: currentTowingRows,
//             storage_rows: currentStorageRows
//           }
//         },
//         {
//           table_key: membershipDataRef.current?.table_key || cfg.membershipKey,
//           title: membershipDataRef.current?.title || cfg.membershipFallback.title,
//           data: { rows: currentMembershipRows }
//         },
//         {
//           table_key: tariffDataRef.current?.table_key || cfg.tariffKey,
//           title: tariffDataRef.current?.title || cfg.tariffFallback.title,
//           data: { rows: currentTariffRows }
//         },
//       ];

//       const res = await apiCall('POST', '/boardpack/add-tables-data', { 
//         contract, year, month: monthNumber, created_by: 1, tables 
//       });
      
//       if (!res?.success) throw new Error(res?.message);
//       toast.success('Data saved successfully');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   if (!profileData || !assetsData || !violationData || !membershipData || !tariffData) {
//     return <LoadingComponent/>;
//   }

//   const pd = profileData.data;
//   const flatAssets = groupsToFlat(assetsData.data.groups);

//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header exactly as image: Logo left, title center ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={DigitalCity} alt="Digital City Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
//         <div className="w-[50px]"></div> {/* spacer for symmetry */}
//       </div>

//       {/* Main container: !border-2 black, flex row on large screens */}
//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ══ LEFT SECTION (Profile Info + Violations + Tariff + Membership) ══ */}
//         <div className="flex-1 pr-4">

//           {/* Car Park icon + Profile fields (exactly as per image layout) */}
//           <div className="flex items-start gap-4 mb-4">
//             <div className="flex-shrink-0">
//               <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
//             </div>
//             <div className="flex flex-col gap-1">
//               <div className="flex items-center gap-2">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.total_bays?.value || ''}
//                       ref={totalBaysRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0  text-[12px] w-20" 
//                     />
//                   </strong>
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center flex-wrap gap-1">
//                   Contract term{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.contract_term?.value || ''}
//                       ref={contractTermRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0  text-[12px] w-20" 
//                     />
//                   </strong>
//                   ; start date{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.contract_period?.start_date || ''}
//                       ref={contractStartDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0  text-[12px] w-32" 
//                     />
//                   </strong>
//                   {' to '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.contract_period?.end_date || ''}
//                       ref={contractEndDateRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0  text-[12px] w-32" 
//                     />
//                   </strong>
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                   Operational Hours{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.operational_hours?.value || ''}
//                       ref={operationalHoursRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0  text-[12px] w-32" 
//                     />
//                   </strong>
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                   Rate per Hour{' '}
//                   <strong>
//                     <input 
//                       type="text" 
//                       defaultValue={pd.rate_per_hour?.value || ''}
//                       ref={ratePerHourRef}
//                       onChange={autoSave}
//                       className="font-bold outline-none bg-transparent !border-0  text-[12px] w-40" 
//                     />
//                   </strong>
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px]">
//                   <input 
//                     type="text" 
//                     defaultValue={pd.membership_tariff?.value || ''}
//                     ref={membershipTariffRef}
//                     onChange={autoSave}
//                     className="outline-none bg-transparent !border-0  text-[12px] w-64" 
//                   />
//                 </span>
//               </div>
//               <div className="flex items-center gap-2 ml-4">
//                 <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                 <span className="text-[12px]">Assets Deployed</span>
//               </div>
//             </div>
//           </div>

// <div className='flex flex-row gap-2'>
//  {/* ── Violations Table (exact structure as image) ── */}
//           <div className="mt-2">
//             <table className="!border-collapse text-[8px] w-full !border !border-black">
//               <thead>
//                 <tr>
//                   <th colSpan={5} className="!border !border-black px-2 py-1.5  text-left font-bold text-[9px]">
//                     {violationData.title}
//                   </th>
//                 </tr>
//                 <tr className="">
//                   <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '200px' }}>Violation Types</th>
//                   <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '80px' }}>First CN</th>
//                   <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '70px' }}>Second CN</th>
//                   <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '70px' }}>Subsequent CN</th>
//                   <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '160px' }}>Escalation Notes</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {violationData.data.rows.map((row, rIdx) => (
//                   <tr key={rIdx} >
//                     <td className="!border !border-black px-1 py-0.5">
//                       {/* <input 
//                         type="text" 
//                         defaultValue={row.violation_type || ''} 
//                         ref={(el) => { violationTypeRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       /> */}
//                       <textarea
// defaultValue={row.violation_type || ''} 
//                         ref={(el) => { violationTypeRefs.current[rIdx] = el; }}
//                         onChange={autoSave}      rows={1}
//       className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
//       style={{
//         // width: w,          // same as input width
//         minWidth: '260px', // same as your first snippet
//         minHeight: '22px',
//         lineHeight: '1.2',
//         padding: '3px 4px',
//       }}
//       onInput={e => {
//         e.target.style.height = 'auto';
//         e.target.style.height = e.target.scrollHeight + 'px';
//       }}
//     />
//                     </td>
//                     {
//                       row?.colSpan ? <>
//                       <td colSpan={3} className="!border !border-black px-1 py-0.5">
//                       <input 
//                         type="text" 
//                         defaultValue={row.first_cn || ''} 
//                         ref={(el) => { violationFirstCnRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       />
//                     </td>
//                     <td rowSpan={5} className="!border !border-black px-1 py-0.5"></td>
//                       </>:<>
//                       <td className="!border !border-black px-1 py-0.5">
//                       <input 
//                         type="text" 
//                         defaultValue={row.first_cn || ''} 
//                         ref={(el) => { violationFirstCnRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       />
//                     </td>
//                     <td className="!border !border-black px-1 py-0.5">
//                       <input 
//                         type="text" 
//                         defaultValue={row.second_cn || ''} 
//                         ref={(el) => { violationSecondCnRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       />
//                     </td>
//                     <td className="!border !border-black px-1 py-0.5">
//                       <input 
//                         type="text" 
//                         defaultValue={row.subsequent_cn || ''} 
//                         ref={(el) => { violationSubsequentCnRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       />
//                     </td>
//                     {
//                       row?.escalation_notes !== null && <td className="!border !border-black px-1 py-0.5">
//                       {/* <input 
//                         type="text" 
//                         defaultValue={row.escalation_notes || ''} 
//                         ref={(el) => { violationEscalationRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       /> */}
//                       <textarea
//                       defaultValue={row.escalation_notes || ''} 
//                         ref={(el) => { violationEscalationRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//       rows={1}
//       className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
//       style={{
//         // width: w,          // same as input width
//         minWidth: '260px', // same as your first snippet
//         minHeight: '22px',
//         lineHeight: '1.2',
//         padding: '3px 4px',
//       }}
//       onInput={e => {
//         e.target.style.height = 'auto';
//         e.target.style.height = e.target.scrollHeight + 'px';
//       }}
//     />
//                     </td>
//                     }
                   
//                       </>
//                     }
                    
//                   </tr>
//                 ))}

//                 {/* Towing Charge Details section */}
//                 <tr>
//                   <td className="!border !border-black px-2 py-0.5 font-bold  text-[8px]">Towing Charge Details</td>
//                   <td className="!border !border-black px-2 py-0.5 font-bold  text-[8px]" colSpan={3}>Amount</td>
//                   {/* <td colSpan={3} className="!border !border-black" /> */}
//                 </tr>
//                 {violationData.data.towing_rows.map((row, rIdx) => (
//                   <tr key={`towing-${rIdx}`} className="bg-white">
//                     <td className="!border !border-black px-1 py-0.5">
//                       <input 
//                         type="text" 
//                         defaultValue={row.charge_type || ''} 
//                         ref={(el) => { towingTypeRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       />
//                     </td>
//                     <td className="!border !border-black px-1 py-0.5" colSpan={3}>
//                       <input 
//                         type="text" 
//                         defaultValue={row.amount || ''} 
//                         ref={(el) => { towingAmountRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-20" 
//                       />
//                     </td>
//                     {/* <td colSpan={3} className="!border !border-black" /> */}
//                   </tr>
//                 ))}

//                 {/* Storage Charge Details section */}
//                 <tr>
//                   <td className="!border !border-black px-2 py-0.5 font-bold  text-[8px]">Storage Charge Details</td>
//                   <td className="!border !border-black px-2 py-0.5 font-bold text-[8px]" colSpan={3}>Amount</td>
//                   <td colSpan={1} className="!border !border-black" />
//                 </tr>
//                 {violationData.data.storage_rows.map((row, rIdx) => (
//                   <tr key={`storage-${rIdx}`} className="bg-white">
//                     <td className="!border !border-black px-1 py-0.5">
//                       <input 
//                         type="text" 
//                         defaultValue={row.charge_type || ''} 
//                         ref={(el) => { storageTypeRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       />
//                     </td>
//                     <td className="!border !border-black px-1 py-0.5" colSpan={3}>
//                       <input 
//                         type="text" 
//                         defaultValue={row.amount || ''} 
//                         ref={(el) => { storageAmountRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-20" 
//                       />
//                     </td>
//                     <td colSpan={1} className="!border !border-black px-1 py-0.5">
//                       {/* <input 
//                         type="text" 
//                         defaultValue={row.notes || ''} 
//                         ref={(el) => { storageNotesRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//                         className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                       /> */}

//                        <textarea
//                       defaultValue={row.notes || ''} 
//                         ref={(el) => { storageNotesRefs.current[rIdx] = el; }}
//                         onChange={autoSave}
//       rows={1}
//       className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
//       style={{
//         // width: w,          // same as input width
//         minWidth: '260px', // same as your first snippet
//         minHeight: '22px',
//         lineHeight: '1.2',
//         padding: '3px 4px',
//       }}
//       onInput={e => {
//         e.target.style.height = 'auto';
//         e.target.style.height = e.target.scrollHeight + 'px';
//       }}
//     />
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* ── Visitor Tariff + Memberships side by side (exactly as image) ── */}
//           <div className="flex gap-4 mt-4 flex-col">
//             {/* Visitor Parking Tariff Table */}
//             <div className="flex-shrink-0">
//               <table className="!border-collapse text-[8px] !border !border-black">
//                 <thead>
//                   <tr>
//                     <th colSpan={2} className="!border !border-black px-2 py-1.5  text-start font-bold text-[9px]">
//                       {tariffData.title}
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tariffData.data.rows.map((row, rIdx) => (
//                     <tr key={rIdx} className="bg-white">
//                       <td className="!border !border-black px-2 py-0.5">
//                         <input 
//                           type="text" 
//                           defaultValue={row.duration || ''} 
//                           ref={(el) => { tariffDurationRefs.current[rIdx] = el; }}
//                           onChange={autoSave}
//                           className="!border-0 bg-transparent outline-none text-[8px] w-20" 
//                         />
//                       </td>
//                       <td className="!border !border-black px-2 py-0.5 text-center">
//                         <input 
//                           type="text" 
//                           defaultValue={row.rate || ''} 
//                           ref={(el) => { tariffRateRefs.current[rIdx] = el; }}
//                           onChange={autoSave}
//                           className="!border-0 bg-transparent outline-none text-[8px] text-center w-16" 
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Memberships Table */}
//             <div className="flex-1">
//               <table className="!border-collapse text-[8px] w-full !border !border-black">
//                 <thead>
//                   <tr>
//                     <th colSpan={3} className="!border !border-black px-2 py-1.5 text-start font-bold text-[9px]">
//                       {membershipData.title}
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {membershipData.data.rows.map((row, rIdx) => (
//                     <tr key={rIdx} className="bg-white">
//                       <td className="!border !border-black px-2 py-0.5" style={{ minWidth: '180px' }}>
//                         <input 
//                           type="text" 
//                           defaultValue={row.category || ''} 
//                           ref={(el) => { membershipCategoryRefs.current[rIdx] = el; }}
//                           onChange={autoSave}
//                           className="!border-0 bg-transparent outline-none text-[8px] w-full" 
//                         />
//                       </td>
//                       <td className="!border !border-black px-2 py-0.5 text-center" style={{ minWidth: '60px' }}>
//                         <input 
//                           type="text" 
//                           defaultValue={row.amount || ''} 
//                           ref={(el) => { membershipAmountRefs.current[rIdx] = el; }}
//                           onChange={autoSave}
//                           className="!border-0 bg-transparent outline-none text-[8px] text-left w-16" 
//                         />
//                       </td>
//                       <td className="!border !border-black px-2 py-0.5 text-center" style={{ minWidth: '60px' }}>
//                         <input 
//                           type="text" 
//                           defaultValue={row.period || ''} 
//                           ref={(el) => { membershipPeriodRefs.current[rIdx] = el; }}
//                           onChange={autoSave}
//                           className="!border-0 bg-transparent outline-none text-[8px] text-left w-16" 
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
// </div>
         
//         </div>

//         {/* ══ RIGHT — Assets Panel (exactly as original, no changes) ══ */}
//         <AssetsPanel
//           assetsTable={assetsData}
//           flatAssets={flatAssets}
//           subCountRefs={assetSubCountRefs}
//           totalCountRefs={assetTotalCountRefs}
//           onSubCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], subCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//           onTotalCount={(index, value) => {
//             const updatedFlat = [...flatAssets];
//             updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
//             setAssetsData(prev => ({
//               ...prev,
//               data: { ...prev.data, groups: flatToGroups(updatedFlat) }
//             }));
//             assetsDataRef.current = {
//               ...assetsDataRef.current,
//               data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
//             };
//             autoSave();
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default DigitalCityOffStreetProfile;


















import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import DigitalCity from '@/assets/img/DigitalCity.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import LoadingComponent from '@/components/common/LoadingComponent';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser',    group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier',     group_total_qty: o.ticketVerifier  ?? '-', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's",               group_total_qty: o.apms            ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad',             group_total_qty: o.pinPad          ?? '-', items: [{ item_name: 'IUP250', qty: '-' }] },
    { group_name: 'Card Reader',         group_total_qty: o.cardReader      ?? '-', items: [{ item_name: 'IUR250', qty: o.iur250 ?? '-' }] },
    { group_name: 'B-Contactless',       group_total_qty: o.bContactless    ?? '-', items: [{ item_name: 'IUC150', qty: '-' }] },
    { group_name: 'RFID Reader',         group_total_qty: o.rfidReader      ?? '-', items: [] },
    { group_name: 'IP Barrier',          group_total_qty: o.ipBarrier       ?? '-', items: [] },
    { group_name: 'ANPR CAMERA',         group_total_qty: o.anprCamera      ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate',        group_total_qty: o.slidingGate     ?? '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
    { group_name: "PND's",               group_total_qty: o.pnds            ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-',                      items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device',       group_total_qty: '-',                      items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device',          group_total_qty: o.enfDevice       ?? '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
    { group_name: 'Validation',          group_total_qty: '-',                      items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer',             group_total_qty: o.printer         ?? '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
    { group_name: 'Tow Truck',           group_total_qty: o.towTruck        ?? '-', items: [] },
    { group_name: 'Clamp Vehicle',       group_total_qty: o.clampVehicle    ?? '-', items: [] },
    { group_name: 'Support Vehicle',     group_total_qty: o.supportVehicle  ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const DIGITAL_CITY_OFF_STREET_CONFIG = {
  digital_city_off_street_profile: {
    profileKey:    'digital_city_off_street_profile',
    violationKey:  'digital_city_off_street_violations',
    membershipKey: 'digital_city_off_street_membership',
    tariffKey:     'digital_city_off_street_tariff',
    assetsKey:     'digital_city_off_street_assets',
    pageType:      'off_street',

    profileFallback: {
      table_key: 'digital_city_off_street_profile',
      title: 'Digital City Off Street - Profile',
      data: {
        total_bays:        { label: 'Total Off Street Car Park Bays', value: '6,736' },
        contract_term:     { value: '05 years' },
        contract_period:   { start_date: '01st April 2025', end_date: '31st March 2030' },
        operational_hours: { value: '12 Hours Per day' },
        rate_per_hour:     { value: 'As per below table' },
        membership_tariff: { value: 'Membership Rates: As per below table' },
      },
    },

    violationFallback: {
      table_key: 'digital_city_off_street_violations',
      title: 'OFF STREET VIOLATIONS',
      data: {
        rows: [
          { violation_type: 'Not parked within the parking space',                                               first_cn: '300', second_cn: '575', subsequent_cn: '575', escalation_notes: '2nd violation - clamping, 3rd violation - Removal to the pound' },
          { violation_type: 'Parked in an official reserved space',                                              first_cn: '300', second_cn: '575', subsequent_cn: '575', escalation_notes: 'Towing/Clamping/Pound' },
          { violation_type: 'Parked in a prohibited parking space',                                              first_cn: '300', second_cn: '575', subsequent_cn: '575', escalation_notes: 'Towing/Clamping/Pound' },
          { violation_type: 'Placing obstacles or reservations on the parking',                                  first_cn: '400', second_cn: '600', subsequent_cn: '900', escalation_notes: 'Cost of removing' },
          { violation_type: 'Parking in front of doorway, pedestrian entry and exits',                          first_cn: '900', second_cn: '900', subsequent_cn: '900', escalation_notes: 'Towing/Pound' },
          { violation_type: 'Parked the Vehicle on pedestrian area, double parking or building entries and exits', first_cn: '575', second_cn: '575', subsequent_cn: '575', escalation_notes: 'Towing/Pound' },
          { violation_type: 'Abusive behavior',                                                                  first_cn: 'Removal of Parking Access',colSpan: 3,escalation_notes: '' },
          { violation_type: 'Blocking an Entrance',                                                              first_cn: '575', second_cn: '900', subsequent_cn: '900', escalation_notes: null },
          { violation_type: 'Parking in a Non-parking area',                                                     first_cn: '575', second_cn: '575', subsequent_cn: '575', escalation_notes: null },
          { violation_type: 'Parking in handicapped spaces without a permit',                                    first_cn: '575', second_cn: '575', subsequent_cn: '575', escalation_notes: null },
          { violation_type: 'Forced Entry',                                                                      first_cn: '900', second_cn: '900', subsequent_cn: '900', escalation_notes: null },
        ],
        towing_rows: [
          { charge_type: 'Towing light Vehicles Charge', amount: '300' },
          { charge_type: 'Towing Heavy Vehicles',        amount: '1000' },
        ],
        storage_rows: [
          { charge_type: 'Daily delay in light vehicle retrieval',  amount: '100', notes: 'Daily Storage amount, Violation fee is charged separately' },
          { charge_type: 'Daily delay in heavy vehicle retrieval',  amount: '300', notes: 'Daily Storage amount, Violation fee is charged separately' },
        ],
      },
    },

    membershipFallback: {
      table_key: 'digital_city_off_street_membership',
      title: 'Off Street memberships',
      data: {
        rows: [
          { category: 'Basement Car Parks',             amount: '2,500', period: '30,000' },
          { category: 'Basement Car Parks Reserved bay', amount: '4,000', period: '48,000' },
          { category: 'Surface Car Park (TE01)',         amount: '1,200', period: '14,400' },
          { category: 'Basement Car Park SPAGA',         amount: '1,500', period: '1,800'  },
          { category: 'Surface Car Park SPAGA',          amount: '1,000', period: '12,000' },
        ],
      },
    },

    tariffFallback: {
      table_key: 'digital_city_off_street_tariff',
      title: 'Off Street visitor parking (PK-01)',
      data: {
        rows: [
          { duration: '1-3 Hours',  rate: '30'  },
          { duration: '4-6 Hours',  rate: '60'  },
          { duration: '7-9 Hours',  rate: '90'  },
          { duration: '9+ Hours',   rate: '300' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'digital_city_off_street_assets',
      title: 'Digital City Off Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '15', dipG100: '15',
          ticketVerifier: '15', evG10064: '15',
          apms: '3', apmEts70: '3',
          pinPad: '3', cardReader: '3', iur250: '3',
          bContactless: '3',
          rfidReader: '-', ipBarrier: '-', anprCamera: '-',
          slidingGate: '-', pnds: '-',
          enfDevice: '-', printer: '-',
          towTruck: '-', clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },
};

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const DigitalCityOffStreetProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = DIGITAL_CITY_OFF_STREET_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileData, setProfileData] = useState(null);
  const [assetsData, setAssetsData] = useState(null);
  const [violationData, setViolationData] = useState(null);
  const [membershipData, setMembershipData] = useState(null);
  const [tariffData, setTariffData] = useState(null);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileData?.data?.total_bays?.value ?? '6,736';

  // Refs for profile inputs
  // 🔥 REMOVED: totalBaysRef (ab readonly hai)
  const contractTermRef = useRef(null);
  const contractStartDateRef = useRef(null);
  const contractEndDateRef = useRef(null);
  const operationalHoursRef = useRef(null);
  const ratePerHourRef = useRef(null);
  const membershipTariffRef = useRef(null);

  // Refs for violation rows
  const violationTypeRefs = useRef([]);
  const violationFirstCnRefs = useRef([]);
  const violationSecondCnRefs = useRef([]);
  const violationSubsequentCnRefs = useRef([]);
  const violationEscalationRefs = useRef([]);

  // Refs for towing rows
  const towingTypeRefs = useRef([]);
  const towingAmountRefs = useRef([]);

  // Refs for storage rows
  const storageTypeRefs = useRef([]);
  const storageAmountRefs = useRef([]);
  const storageNotesRefs = useRef([]);

  // Refs for membership rows
  const membershipCategoryRefs = useRef([]);
  const membershipAmountRefs = useRef([]);
  const membershipPeriodRefs = useRef([]);

  // Refs for tariff rows
  const tariffDurationRefs = useRef([]);
  const tariffRateRefs = useRef([]);

  // Refs for assets
  const assetSubCountRefs = useRef([]);
  const assetTotalCountRefs = useRef([]);

  // State refs for data
  const profileDataRef = useRef(null);
  const assetsDataRef = useRef(null);
  const violationDataRef = useRef(null);
  const membershipDataRef = useRef(null);
  const tariffDataRef = useRef(null);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params
      const secondApiParams = {
        contract: "1501005",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        
        const profile = find(cfg.profileKey, cfg.profileFallback);
        const assets = find(cfg.assetsKey, cfg.assetsFallback);
        const violation = find(cfg.violationKey, cfg.violationFallback);
        const membership = find(cfg.membershipKey, cfg.membershipFallback);
        const tariff = find(cfg.tariffKey, cfg.tariffFallback);
        
        setProfileData(profile);
        setAssetsData(assets);
        setViolationData(violation);
        setMembershipData(membership);
        setTariffData(tariff);
        
        profileDataRef.current = profile;
        assetsDataRef.current = assets;
        violationDataRef.current = violation;
        membershipDataRef.current = membership;
        tariffDataRef.current = tariff;
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // Auto-save
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const transformAssetsToApiFormat = () => {
    const currentAssets = assetsDataRef.current?.data?.groups || [];
    const groups = [];
    let currentGroup = null;
    let flatIdx = 0;

    currentAssets.forEach((group) => {
      currentGroup = {
        group_name: group.group_name,
        group_total_qty: assetTotalCountRefs.current[flatIdx]?.value || group.group_total_qty || '-',
        items: []
      };
      flatIdx++;

      (group.items || []).forEach((item) => {
        currentGroup.items.push({
          item_name: item.item_name,
          qty: assetSubCountRefs.current[flatIdx]?.value || item.qty || '-'
        });
        flatIdx++;
      });

      groups.push(currentGroup);
    });

    return groups;
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      // 🔥 totalBays - ab read-only value use karo
      const currentTotalBays = effectiveTotalBays;
      const currentContractTerm = contractTermRef.current?.value || profileDataRef.current?.data?.contract_term?.value || '';
      const currentStartDate = contractStartDateRef.current?.value || profileDataRef.current?.data?.contract_period?.start_date || '';
      const currentEndDate = contractEndDateRef.current?.value || profileDataRef.current?.data?.contract_period?.end_date || '';
      const currentOperationalHours = operationalHoursRef.current?.value || profileDataRef.current?.data?.operational_hours?.value || '';
      const currentRatePerHour = ratePerHourRef.current?.value || profileDataRef.current?.data?.rate_per_hour?.value || '';
      const currentMembershipTariff = membershipTariffRef.current?.value || profileDataRef.current?.data?.membership_tariff?.value || '';

      // Build violation rows from refs
      const currentViolationRows = (violationDataRef.current?.data?.rows || []).map((row, rIdx) => {
        const newRow = {
          violation_type: violationTypeRefs.current[rIdx]?.value || row.violation_type || '',
          first_cn: violationFirstCnRefs.current[rIdx]?.value || row.first_cn || '',
          second_cn: violationSecondCnRefs.current[rIdx]?.value || row.second_cn || '',
          subsequent_cn: violationSubsequentCnRefs.current[rIdx]?.value || row.subsequent_cn || '',
          escalation_notes: violationEscalationRefs.current[rIdx]?.value || row.escalation_notes || null
        };
        
        if (row.colSpan) {
          newRow.colSpan = row.colSpan;
        }
        
        return newRow;
      });

      // Build towing rows from refs
      const currentTowingRows = (violationDataRef.current?.data?.towing_rows || []).map((row, rIdx) => ({
        charge_type: towingTypeRefs.current[rIdx]?.value || row.charge_type || '',
        amount: towingAmountRefs.current[rIdx]?.value || row.amount || ''
      }));

      // Build storage rows from refs
      const currentStorageRows = (violationDataRef.current?.data?.storage_rows || []).map((row, rIdx) => ({
        charge_type: storageTypeRefs.current[rIdx]?.value || row.charge_type || '',
        amount: storageAmountRefs.current[rIdx]?.value || row.amount || '',
        notes: storageNotesRefs.current[rIdx]?.value || row.notes || ''
      }));

      // Build membership rows from refs
      const currentMembershipRows = (membershipDataRef.current?.data?.rows || []).map((row, rIdx) => ({
        category: membershipCategoryRefs.current[rIdx]?.value || row.category || '',
        amount: membershipAmountRefs.current[rIdx]?.value || row.amount || '',
        period: membershipPeriodRefs.current[rIdx]?.value || row.period || ''
      }));

      // Build tariff rows from refs
      const currentTariffRows = (tariffDataRef.current?.data?.rows || []).map((row, rIdx) => ({
        duration: tariffDurationRefs.current[rIdx]?.value || row.duration || '',
        rate: tariffRateRefs.current[rIdx]?.value || row.rate || ''
      }));

      const tables = [
        {
          table_key: profileDataRef.current?.table_key || cfg.profileKey,
          title: profileDataRef.current?.title || cfg.profileFallback.title,
          data: {
            total_bays: { label: 'Total Off Street Car Park Bays', value: currentTotalBays },
            contract_term: { value: currentContractTerm },
            contract_period: { start_date: currentStartDate, end_date: currentEndDate },
            operational_hours: { value: currentOperationalHours },
            rate_per_hour: { value: currentRatePerHour },
            membership_tariff: { value: currentMembershipTariff }
          }
        },
        {
          table_key: assetsDataRef.current?.table_key || cfg.assetsKey,
          title: assetsDataRef.current?.title || cfg.assetsFallback.title,
          data: { groups: transformAssetsToApiFormat() }
        },
        {
          table_key: violationDataRef.current?.table_key || cfg.violationKey,
          title: violationDataRef.current?.title || cfg.violationFallback.title,
          data: {
            rows: currentViolationRows,
            towing_rows: currentTowingRows,
            storage_rows: currentStorageRows
          }
        },
        {
          table_key: membershipDataRef.current?.table_key || cfg.membershipKey,
          title: membershipDataRef.current?.title || cfg.membershipFallback.title,
          data: { rows: currentMembershipRows }
        },
        {
          table_key: tariffDataRef.current?.table_key || cfg.tariffKey,
          title: tariffDataRef.current?.title || cfg.tariffFallback.title,
          data: { rows: currentTariffRows }
        },
      ];

      const res = await apiCall('POST', '/boardpack/add-tables-data', { 
        contract, year, month: monthNumber, created_by: 1, tables 
      });
      
      if (!res?.success) throw new Error(res?.message);
      // toast.success('Data saved successfully');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  if (!profileData || !assetsData || !violationData || !membershipData || !tariffData) {
    return <LoadingComponent/>;
  }

  const pd = profileData.data;
  const flatAssets = groupsToFlat(assetsData.data.groups);

  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header exactly as image: Logo left, title center ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={DigitalCity} alt="Digital City Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileData.title}</h1>
        <div className="w-[50px]"></div> {/* spacer for symmetry */}
      </div>

      {/* Main container: !border-2 black, flex row on large screens */}
      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ══ LEFT SECTION (Profile Info + Violations + Tariff + Membership) ══ */}
        <div className="flex-1 pr-4" style={{zoom:"85%"}}>

          {/* Car Park icon + Profile fields (exactly as per image layout) */}
          <div className="flex items-start gap-4 mb-4">
            <div className="flex-shrink-0">
              <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
            </div>
            <div className="flex flex-col gap-1">
              {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default" 
                    />
                  </strong>
                </span>
              </div>

              {/* Contract Term - Editable */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center flex-wrap gap-1">
                  Contract term{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.contract_term?.value || ''}
                      ref={contractTermRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20" 
                    />
                  </strong>
                  ; start date{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.contract_period?.start_date || ''}
                      ref={contractStartDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-32" 
                    />
                  </strong>
                  {' to '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.contract_period?.end_date || ''}
                      ref={contractEndDateRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-32" 
                    />
                  </strong>
                </span>
              </div>

              {/* Operational Hours - Editable */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  Operational Hours{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.operational_hours?.value || ''}
                      ref={operationalHoursRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-32" 
                    />
                  </strong>
                </span>
              </div>

              {/* Rate per Hour - Editable */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  Rate per Hour{' '}
                  <strong>
                    <input 
                      type="text" 
                      defaultValue={pd.rate_per_hour?.value || ''}
                      ref={ratePerHourRef}
                      onChange={autoSave}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-40" 
                    />
                  </strong>
                </span>
              </div>

              {/* Membership Tariff - Editable */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px]">
                  <input 
                    type="text" 
                    defaultValue={pd.membership_tariff?.value || ''}
                    ref={membershipTariffRef}
                    onChange={autoSave}
                    className="outline-none bg-transparent !border-0 text-[12px] w-64" 
                  />
                </span>
              </div>

              {/* Assets Deployed */}
              <div className="flex items-center gap-2 ml-4">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>
            </div>
          </div>

          <div className='flex flex-row gap-2'>
            {/* ── Violations Table (exact structure as image) ── */}
            <div className="mt-2">
              <table className="!border-collapse text-[8px] w-full !border !border-black">
                <thead>
                  <tr>
                    <th colSpan={5} className="!border !border-black px-2 py-1.5 text-left font-bold text-[9px]">
                      {violationData.title}
                    </th>
                  </tr>
                  <tr className="">
                    <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '200px' }}>Violation Types</th>
                    <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '80px' }}>First CN</th>
                    <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '70px' }}>Second CN</th>
                    <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '70px' }}>Subsequent CN</th>
                    <th className="!border !border-black px-2 py-1 font-bold text-left text-[8px]" style={{ minWidth: '160px' }}>Escalation Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {violationData.data.rows.map((row, rIdx) => (
                    <tr key={rIdx}>
                      <td className="!border !border-black px-1 py-0.5">
                        <textarea
                          defaultValue={row.violation_type || ''} 
                          ref={(el) => { violationTypeRefs.current[rIdx] = el; }}
                          onChange={autoSave}
                          rows={1}
                          className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
                          style={{ minWidth: '260px', minHeight: '22px', lineHeight: '1.2', padding: '3px 4px' }}
                          onInput={e => {
                            e.target.style.height = 'auto';
                            e.target.style.height = e.target.scrollHeight + 'px';
                          }}
                        />
                      </td>
                      {
                        row?.colSpan ? <>
                          <td colSpan={3} className="!border !border-black px-1 py-0.5">
                            <input 
                              type="text" 
                              defaultValue={row.first_cn || ''} 
                              ref={(el) => { violationFirstCnRefs.current[rIdx] = el; }}
                              onChange={autoSave}
                              className="!border-0 bg-transparent outline-none text-[8px] w-full" 
                            />
                          </td>
                          <td rowSpan={5} className="!border !border-black px-1 py-0.5"></td>
                        </> : <>
                          <td className="!border !border-black px-1 py-0.5">
                            <input 
                              type="text" 
                              defaultValue={row.first_cn || ''} 
                              ref={(el) => { violationFirstCnRefs.current[rIdx] = el; }}
                              onChange={autoSave}
                              className="!border-0 bg-transparent outline-none text-[8px] w-full" 
                            />
                          </td>
                          <td className="!border !border-black px-1 py-0.5">
                            <input 
                              type="text" 
                              defaultValue={row.second_cn || ''} 
                              ref={(el) => { violationSecondCnRefs.current[rIdx] = el; }}
                              onChange={autoSave}
                              className="!border-0 bg-transparent outline-none text-[8px] w-full" 
                            />
                          </td>
                          <td className="!border !border-black px-1 py-0.5">
                            <input 
                              type="text" 
                              defaultValue={row.subsequent_cn || ''} 
                              ref={(el) => { violationSubsequentCnRefs.current[rIdx] = el; }}
                              onChange={autoSave}
                              className="!border-0 bg-transparent outline-none text-[8px] w-full" 
                            />
                          </td>
                          {
                            row?.escalation_notes !== null && <td className="!border !border-black px-1 py-0.5">
                              <textarea
                                defaultValue={row.escalation_notes || ''} 
                                ref={(el) => { violationEscalationRefs.current[rIdx] = el; }}
                                onChange={autoSave}
                                rows={1}
                                className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
                                style={{ minWidth: '260px', minHeight: '22px', lineHeight: '1.2', padding: '3px 4px' }}
                                onInput={e => {
                                  e.target.style.height = 'auto';
                                  e.target.style.height = e.target.scrollHeight + 'px';
                                }}
                              />
                            </td>
                          }
                        </>
                      }
                    </tr>
                  ))}

                  {/* Towing Charge Details section */}
                  <tr>
                    <td className="!border !border-black px-2 py-0.5 font-bold text-[8px]">Towing Charge Details</td>
                    <td className="!border !border-black px-2 py-0.5 font-bold text-[8px]" colSpan={3}>Amount</td>
                  </tr>
                  {violationData.data.towing_rows.map((row, rIdx) => (
                    <tr key={`towing-${rIdx}`} className="bg-white">
                      <td className="!border !border-black px-1 py-0.5">
                        <input 
                          type="text" 
                          defaultValue={row.charge_type || ''} 
                          ref={(el) => { towingTypeRefs.current[rIdx] = el; }}
                          onChange={autoSave}
                          className="!border-0 bg-transparent outline-none text-[8px] w-full" 
                        />
                      </td>
                      <td className="!border !border-black px-1 py-0.5" colSpan={3}>
                        <input 
                          type="text" 
                          defaultValue={row.amount || ''} 
                          ref={(el) => { towingAmountRefs.current[rIdx] = el; }}
                          onChange={autoSave}
                          className="!border-0 bg-transparent outline-none text-[8px] w-20" 
                        />
                      </td>
                    </tr>
                  ))}

                  {/* Storage Charge Details section */}
                  <tr>
                    <td className="!border !border-black px-2 py-0.5 font-bold text-[8px]">Storage Charge Details</td>
                    <td className="!border !border-black px-2 py-0.5 font-bold text-[8px]" colSpan={3}>Amount</td>
                    <td colSpan={1} className="!border !border-black" />
                  </tr>
                  {violationData.data.storage_rows.map((row, rIdx) => (
                    <tr key={`storage-${rIdx}`} className="bg-white">
                      <td className="!border !border-black px-1 py-0.5">
                        <input 
                          type="text" 
                          defaultValue={row.charge_type || ''} 
                          ref={(el) => { storageTypeRefs.current[rIdx] = el; }}
                          onChange={autoSave}
                          className="!border-0 bg-transparent outline-none text-[8px] w-full" 
                        />
                      </td>
                      <td className="!border !border-black px-1 py-0.5" colSpan={3}>
                        <input 
                          type="text" 
                          defaultValue={row.amount || ''} 
                          ref={(el) => { storageAmountRefs.current[rIdx] = el; }}
                          onChange={autoSave}
                          className="!border-0 bg-transparent outline-none text-[8px] w-20" 
                        />
                      </td>
                      <td colSpan={1} className="!border !border-black px-1 py-0.5">
                        <textarea
                          defaultValue={row.notes || ''} 
                          ref={(el) => { storageNotesRefs.current[rIdx] = el; }}
                          onChange={autoSave}
                          rows={1}
                          className="!border-0 bg-transparent outline-none text-[8px] text-left resize-none overflow-hidden"
                          style={{ minWidth: '260px', minHeight: '22px', lineHeight: '1.2', padding: '3px 4px' }}
                          onInput={e => {
                            e.target.style.height = 'auto';
                            e.target.style.height = e.target.scrollHeight + 'px';
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ── Visitor Tariff + Memberships side by side (exactly as image) ── */}
            <div className="flex gap-4 mt-4 flex-col">
              {/* Visitor Parking Tariff Table - Editable */}
              <div className="flex-shrink-0">
                <table className="!border-collapse text-[8px] !border !border-black">
                  <thead>
                    <tr>
                      <th colSpan={2} className="!border !border-black px-2 py-1.5 text-start font-bold text-[9px]">
                        {tariffData.title}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tariffData.data.rows.map((row, rIdx) => (
                      <tr key={rIdx} className="bg-white">
                        <td className="!border !border-black px-2 py-0.5">
                          <input 
                            type="text" 
                            defaultValue={row.duration || ''} 
                            ref={(el) => { tariffDurationRefs.current[rIdx] = el; }}
                            onChange={autoSave}
                            className="!border-0 bg-transparent outline-none text-[8px] w-20" 
                          />
                        </td>
                        <td className="!border !border-black px-2 py-0.5 text-center">
                          <input 
                            type="text" 
                            defaultValue={row.rate || ''} 
                            ref={(el) => { tariffRateRefs.current[rIdx] = el; }}
                            onChange={autoSave}
                            className="!border-0 bg-transparent outline-none text-[8px] text-center w-16" 
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Memberships Table - Editable */}
              <div className="flex-1">
                <table className="!border-collapse text-[8px] w-full !border !border-black">
                  <thead>
                    <tr>
                      <th colSpan={3} className="!border !border-black px-2 py-1.5 text-start font-bold text-[9px]">
                        {membershipData.title}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {membershipData.data.rows.map((row, rIdx) => (
                      <tr key={rIdx} className="bg-white">
                        <td className="!border !border-black px-2 py-0.5" style={{ minWidth: '180px' }}>
                          <input 
                            type="text" 
                            defaultValue={row.category || ''} 
                            ref={(el) => { membershipCategoryRefs.current[rIdx] = el; }}
                            onChange={autoSave}
                            className="!border-0 bg-transparent outline-none text-[8px] w-full" 
                          />
                        </td>
                        <td className="!border !border-black px-2 py-0.5 text-center" style={{ minWidth: '60px' }}>
                          <input 
                            type="text" 
                            defaultValue={row.amount || ''} 
                            ref={(el) => { membershipAmountRefs.current[rIdx] = el; }}
                            onChange={autoSave}
                            className="!border-0 bg-transparent outline-none text-[8px] text-left w-16" 
                          />
                        </td>
                        <td className="!border !border-black px-2 py-0.5 text-center" style={{ minWidth: '60px' }}>
                          <input 
                            type="text" 
                            defaultValue={row.period || ''} 
                            ref={(el) => { membershipPeriodRefs.current[rIdx] = el; }}
                            onChange={autoSave}
                            className="!border-0 bg-transparent outline-none text-[8px] text-left w-16" 
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* ══ RIGHT — Assets Panel ══ */}
        <AssetsPanel
          assetsTable={assetsData}
          flatAssets={flatAssets}
          subCountRefs={assetSubCountRefs}
          totalCountRefs={assetTotalCountRefs}
          onSubCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], subCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
          onTotalCount={(index, value) => {
            const updatedFlat = [...flatAssets];
            updatedFlat[index] = { ...updatedFlat[index], totalCount: value };
            setAssetsData(prev => ({
              ...prev,
              data: { ...prev.data, groups: flatToGroups(updatedFlat) }
            }));
            assetsDataRef.current = {
              ...assetsDataRef.current,
              data: { ...assetsDataRef.current.data, groups: flatToGroups(updatedFlat) }
            };
            autoSave();
          }}
        />
      </div>
    </div>
  );
};

export default DigitalCityOffStreetProfile;